export function clearEmptyProperties<T extends object>(obj: T | null | undefined): Partial<T> {
  if (!obj) {
    return {};
  }

  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null)) as Partial<T>;
}
